<div class="screen">

    <!-- HEADER -->
     <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/transfer-unsuccessful.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Transfer Unsuccessful</div>
  
      <div class="subtitle">
        Your bank didn't approve your 
        transfer. No money was taken from 
        your account.
      </div>
    </div>
    <br/>
    <!-- BUTTON -->
        <!--<button pButton label="VIEW DETAILS" class="confirm-btn"></button>-->

        <footer class="screen-footer">
          <button pButton label="DONE" class="edit-btn" (click)="done()"></button>  
        </footer>
    </div>   

